import posthog from 'posthog-js';

/**
 * Initialize PostHog analytics
 * Call this before rendering the app in main.tsx
 */
export function initPostHog() {
  if (import.meta.env.VITE_PUBLIC_POSTHOG_KEY) {
    try {
      posthog.init(import.meta.env.VITE_PUBLIC_POSTHOG_KEY, {
        api_host: 'https://us.i.posthog.com',
        capture_pageview: 'history_change', // Auto-track SPA navigation
        capture_pageleave: true,
        persistence: 'localStorage',
      });
    } catch (error) {
      // Continue without analytics rather than crashing
      console.error('PostHog initialization failed:', error);
    }
  }
}

export { posthog };
